import { Children, ReactNode } from 'react';

type InputProps = string | undefined | null;

export const sentenceCase = (str: InputProps) => {
  if (!str || typeof str === 'undefined') {
    return '';
  }

  return str
    .toString()
    .toLowerCase()
    .split(' ')
    .map((word: string) =>
      word.charAt(0).toUpperCase().concat(word.substring(1))
    )
    .join(' ');
};

export const convertChildrenToSentenceCase = (
  children: ReactNode,
  sentenceCased: boolean | undefined
) => {
  if (sentenceCased) {
    return Children.map(children, (child) =>
      typeof child === 'string' ? sentenceCase(child) : child
    );
  }
  return children;
};
